import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

// ¿Puede el usuario actual gestionar equipo (pantalla /equipo)?
// Sí cuando es OWNER de una organización con plan Productora o Estudio vigente. Es el mismo
// criterio que aplica la edge function `org-team` (si no, responde 403), así que esto solo
// decide si se muestra el enlace y se deja entrar a la pantalla.
//
// OJO: no usar `isOwner` de useAuth para esto. Ese `isOwner` es el rol de PLATAFORMA
// (profiles.role = 'owner', solo el equipo de Pelip), no el de dueño de una organización.
// Con él, ningún cliente de Productora o Estudio veía el enlace ni podía entrar.
const PLANES_CON_EQUIPO = ['productora', 'estudio'];

export function useCanManageTeam(enabled = true) {
  return useQuery<boolean>({
    queryKey: ['can-manage-team'],
    enabled,
    queryFn: async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      const userId = sessionData.session?.user?.id;
      if (!userId) return false;

      // Un usuario puede tener varias membresías: basta con ser owner de UNA con plan de equipo.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data: mems, error: memErr } = await (supabase as any)
        .from('organization_members')
        .select('org_id, role')
        .eq('user_id', userId)
        .eq('role', 'owner');
      if (memErr) throw memErr;
      const orgIds = ((mems as { org_id: string }[] | null) || []).map((m) => m.org_id);
      if (!orgIds.length) return false;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data: orgs, error } = await (supabase as any)
        .from('organizations')
        .select('plan, plan_expires_at')
        .in('id', orgIds);
      if (error) throw error;

      const ahora = Date.now();
      return ((orgs as { plan: string; plan_expires_at: string | null }[] | null) || []).some(
        (o) =>
          PLANES_CON_EQUIPO.includes(o.plan) &&
          (!o.plan_expires_at || Date.parse(o.plan_expires_at) > ahora),
      );
    },
  });
}
